export const CONCIERGE_EXPERIENCE_VIEWED = 'ce_viewed'

export const setConciergeExperienceViewed = () => {
  window.sessionStorage.setItem(CONCIERGE_EXPERIENCE_VIEWED, 'true')
}

export const isConciergeExperienceAlreadyViewed = () =>
  window.sessionStorage.getItem(CONCIERGE_EXPERIENCE_VIEWED) === 'true'
